/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_TrainingInputs */

const en_us2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal and training`)
};

const pt_br2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo e treino`)
};

const es_419_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo y entrenamiento`)
};

const pt_pt2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo e treino`)
};

const fr_fr2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif et entraînement`)
};

const de_de2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel und Training`)
};

const it_it2_profile_page_training = /** @type {(inputs: Profile_Page_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo e allenamento`)
};

/**
* | output |
* | --- |
* | "Goal and training" |
*
* @param {Profile_Page_TrainingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_training = /** @type {((inputs?: Profile_Page_TrainingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_TrainingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_training(inputs)
	if (locale === "es-419") return es_419_profile_page_training(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_training(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_training(inputs)
	if (locale === "de-DE") return de_de2_profile_page_training(inputs)
	if (locale === "it-IT") return it_it2_profile_page_training(inputs)
	return en_us2_profile_page_training(inputs)
});
export { profile_page_training as "profile.page_training" }